<template lang="pug">
md-layout(md-column)
    div(v-if="videos.length > 0")
      div
        div
          label {{ label }}
          div.info-videos
            md-icon.icon-info-videos(md-iconset="fa fa-info-circle")
            p If the video has tags or associated series, they will appear as follows:
              span.tag.sect-series series
              span.tag tags

        div.errorMessage(v-if="containsInvalidItems")
          md-icon.md-icon(md-iconset="fa fa-exclamation-triangle")
          p Some videos may not appear in the final distribution. Please click on each marked video for more details.
      SlickList.videoContainer(lockAxis="y", v-model="videos", @input="onSortEnd", :pressDelay='100').md-list.custom-list.md-triple-line
        SlickItem(v-for="(item, index) in videos", :index="index", :key="item._id").md-list-item.sortable-item.noselect
          .md-list-item-container
            // Avatar
            md-avatar
              img(:src='getVideoPoster(item)', :alt='item.name')
            // Name
            div
              span.title {{ item.name }}
              span.detail {{ formatDuration(item.duration) }}
              span.detail {{ item.credit }}
              div.tagsContainer
                span.tag.sect-series(v-if="item.serie") {{ item.serie.name}}
                div.tagsContainer(v-if="item.tags.length > 0")
                  span.tag(v-for='tag in item.tags') {{ tag }}
            // Actions
            div.btn-container
              md-button.md-icon-button#statusBtnWarning(@click='checkItem(item)' v-if="!item.isValid")
                md-icon.md-icon(md-iconset="fa fa-exclamation-triangle")
              md-button.md-icon-button#statusBtnOk(v-else)
              md-button.md-icon-button.md-raised#btnInfo(@mouseover.native='showInfo(index, true)', @mouseleave.native='showInfo(index, false)' )
                md-icon.md-icon(md-iconset="fa fa-info-circle")
              md-button.md-icon-button.md-warn.md-list-action(@click='removeItem(index)' )
                md-icon.md-icon(md-iconset="fa fa-trash-alt")
              div.info-video(v-if='isShowInfo === index')
                p.text-item(v-if="item.licenses.length > 0") <strong>License: </strong>
                  p(v-for="(license, index) in item.licenses") {{ license.name }} {{ index !== item.licenses.length - 1 ? ', ' : '' }}
                p.text-item(v-if="item.categories") <strong>Categories: </strong>
                  p(v-for="(category, index) in item.categories") {{ category }} {{ index !== item.categories.length - 1 ? ', ' : '' }}
            // Item divider
            md-divider
    // No items message
    div#no-results(v-else)
      md-icon.md-accent(md-iconset="fa fa-exclamation-circle",)
      | No items to show
</template>

<script>
import videoMixin from '../../shared-components/videomixins';
import { SlickList, SlickItem } from 'vue-slicksort';
import { mapState } from 'vuex';

  export default {
    mixins: [videoMixin],
    components: {
      SlickItem,
			SlickList,
    },
    props: {
      allowDelete: {
        type: Boolean,
        default: true
      },
      label: {
        type: String,
        default: 'Content'
      },
      videos: {
        type: Array,
        required: true
      },
      deletingItem: {
        type: Number
      },
      containsInvalidItems: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        isShowInfo: null,
      }
    },
    computed: {
      ...mapState({
        accountID: (state) => state.user.siteuser.user_metadata.account_id,
      }),
      impersonate() {
        return localStorage.getItem('impersonate');
      }
    },
    methods: {
      showInfo(index, value) {
        this.isShowInfo = value ? index : null;
      },

      checkItem(item) {
        let html = `<div style="margin-bottom: 10px;">This video may not be displayed on your channel due to the following reasons:</div>`
        const userAccountID = this.impersonate  ? this.impersonate : this.accountID;
        const isSameAccount = item.account === userAccountID;
        if (isSameAccount) {
        for(const invalidItem of item.invalidReasons){
          if(invalidItem.reason === 'InvalidVideo'){
            html += `<div style="margin-bottom: 10px;">
                      <h5 style="color: darkorange;">The video is not in 'live' status
                        <p style="color: gray; font-size: 14px">
                          <a target="_blank", rel="noopener noreferrer", href='/video/${item._id}' > Click here to update the status to 'live'</a>
                        </p>
                      </h5>
                  </div>`
          }
          if(invalidItem.reason === 'InvalidSerie'){
            html += `<div style="margin-bottom: 10px;">
                      <h5 style="color: darkorange;">The associated series is not in 'live' status
                        <p style="color: gray; font-size: 14px;">
                          <a target="_blank", rel="noopener noreferrer", href='/serie/${item.serie._id}'> Click here to update the series status</a>
                        </p>
                      </h5>
                    </div>`
          }
          if(invalidItem.reason === 'NoLicense'){
            html += `<div style="margin-bottom: 10px;">
                      <h5 style="color: darkorange;">The video does not have a license and requires one
                        <p style="color: gray; font-size: 14px;">
                          <a target="_blank", rel="noopener noreferrer", href='/video/${item._id}'> Click here to add a license</a>
                        </p>
                      </h5>
                    </div>`
          }
          if(invalidItem.reason === 'InvalidLicense'){
            for (const license of invalidItem.licenses){
              html += `<div style="margin-bottom: 10px;">
                        <h5 style="color: darkorange;">License is not 'live' or has invalid dates
                          <p style="color: gray; font-size: 14px;">
                            <a target="_blank", rel="noopener noreferrer", href='/license/${license._id}' > Click here to update the license</a>
                          </p>
                        </h5>
                    </div>`
            }
          }
        }} else{
          html += `<div style="margin-bottom: 10px; color: darkorange;">
                    <h5>The video has a problem and cannot be modified from this account because it does not belong to you</h5>
                  </div>`;
        }
        this.$swal.fire({
          html:html,
          icon: 'warning',
          })
      },

      advisor(item) {

        let checks = [];

        if(!item.tags.length) {
          checks.push('tags');
        }

        if(!item.categories.length) {
          checks.push('categories');
        }

        if(!item.description.length) {
          checks.push('description');
        }

        return checks.length ? `✘ This item is missing ${checks.join(', ')}` : '';
      },
      removeItem(index) {
        this.$emit('removeItem', index);
      },
      onSortEnd(data) {
        this.$emit('customData', data)
      },

      formatDuration(seconds) {
        const h = Math.floor(seconds / 3600).toString().padStart(2, '0');
        const m = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
        const s = Math.floor(seconds % 60).toString().padStart(2, '0');
        return `${h}:${m}:${s}`;
        }
    },

  };
</script>

<style lang="scss" scoped>
  .md-icon.on-left {
    margin-top: -3px;
    margin-right: 5px;
  }
  .noselect {
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select:none; user-select:none;
    -o-user-select:none;
  }
  #no-results{
    margin: auto;
    padding: 20px;
    .md-icon {
      margin-left: 5px;
    }
  }
  .videoContainer{
    border: 1px solid hsla(0,2%,83%,.2);
    padding: 15px;
    width: 100%;
    max-height: 400px;
    overflow-y: auto;
    gap: 15px;
  }
  .errorMessage{
    display: flex;
    & p{
      color: darkorange;
      font-size: 14px;
      margin-bottom: 10px;
    }
    .md-icon{
      margin-left: 5px;
      margin-right: 15px;
      color: darkorange !important;
    }
  }

  .detail {
    display: block;
  }

  #statusBtnWarning{
    background-color: transparent !important;
    box-shadow: none !important;
    transition: all 0.3s ease-in-out;
    :first-child{
      color: darkorange !important;
    }
  }
  #statusBtnWarning:hover{
      background-color: transparent !important;
      opacity: 0.8;
      transform: scale(1.2);
  }

  #statusBtnOk{
    background-color: transparent !important;
  }

  #statusBtnOk:hover{
    cursor: default !important;
  }

  .tagsContainer{
    display: flex;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
}
  .tag{
    padding: 2px 5px;
    margin: 2px;
    border-radius: 6px;
    background-color: #d1dfe3ba;
    font-style: italic;
    font-size: 14px;
    &.sect-series{
      background-color: #bc1f4959;
    }
}
.info-videos{
    display: flex;
    & p{
      font-size: 14px;
      margin-bottom: 10px;
    }
    .md-icon{
      margin-left: 5px;
      margin-right: 15px;
    }
  }

.info-video p{
    margin: 5px;
    margin-right: 5px;
    font-size: 14px;
}

.info-video {
    position: absolute;
    display: flex;
    align-items: center;
    right: 120px;
    bottom: 25px;
    padding: 5px 8px;
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
    z-index: 9999;
}
.text-item{
  color: #acd2dd;
}

#btnInfo{
  background-color: transparent !important;
  box-shadow: none !important;
}
.btn-container{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/shared-components/distribution/DistributionArrangedList.vue